import React from 'react';
import { useTranslation } from 'react-i18next';
import V2Layout from '../components/V2Layout';
import V2AccountNav from '../components/V2AccountNav';
import useV2Auth from '../hooks/useV2Auth';
import V2FilterSettings from '../settings/V2FilterSettings';
import V2RandomizerSettings from '../settings/V2RandomizerSettings';
import V2SearchPreferences from '../settings/V2SearchPreferences';
import '../settings/settings.css';

const V2Settings: React.FC = () => {
  const { t } = useTranslation('translation');
  const { user } = useV2Auth();
  const [compact, setCompact] = React.useState(false);

  if (!user) {
    return null;
  }

  return (
    <V2Layout
      activeNav="profile"
      compact={compact}
      onToggleCompact={() => setCompact((value) => !value)}
      userEmail={user.email}
      breadcrumbs={
        <p className="breadcrumbs">
          {t('profile')} <span>/</span> <strong>{t('settings')}</strong>
        </p>
      }
      footerNote={t('settings')}
    >
      <div className="v2-account-page">
        <section className="player-heading player-heading--page">
          <div>
            <div className="player-title-line">
              <h1>{t('settings')}</h1>
            </div>
            <p className="profile-description">{t('settings_page_description')}</p>
          </div>
        </section>

        <V2AccountNav active="settings" />

        <div className="v2-settings-panels">
          <V2FilterSettings />
          <V2RandomizerSettings />
          <V2SearchPreferences />
        </div>
      </div>
    </V2Layout>
  );
};

export default V2Settings;
